import React from "react";
import Whats from "assets/images/icons/whats.svg";
import FB from "assets/images/icons/fb.svg";
import TT from "assets/images/icons/tt.svg";

import * as S from "./styles";

export const TalkToUsSection: React.FC = () => {
  return (
    <S.Container>
      <S.Address>
        <S.Text>Fale com a gente!</S.Text>
        <S.IconWhats src={Whats} />
        <S.Text2>+55 (11) 4040-9067</S.Text2>
        <S.Text2>contato@parcelamostudo.com.br</S.Text2>
        <S.Text3>

          <strong>Matriz:</strong>
          <br />
          36.063.350/0001-44
          <br />
          Av. Chucri Zaidan, 296
          <br />
          Vila Cordeiro, São Paulo - SP 04583-110

          <br />
          <br />


          <strong>Filial:</strong>
          <br />
          36.063.350/0002-25
          <br />
          Av Fernandes Lima, 8
          <br />
          Farol, Maceió - AL 57.055-000
          <br />
          (82) 3512-1656
        </S.Text3>
      </S.Address>

      <S.LinksContainer>
        <S.CompanyPoliticsAndPrivacyLink to="/termos-de-uso">
          Políticas de Uso
        </S.CompanyPoliticsAndPrivacyLink>{" "}
        <S.CompanyPoliticsAndPrivacyLink
          to=""
          style={{ pointerEvents: "none" }}
        >
          e
        </S.CompanyPoliticsAndPrivacyLink>{" "}
        <S.CompanyPoliticsAndPrivacyLink to="/politica-de-privacidade">
          Privacidade
        </S.CompanyPoliticsAndPrivacyLink>
      </S.LinksContainer>

      <S.Gradient>
        <S.WrapperIcons>
          <S.Link
            href="https://www.facebook.com/parcelamostudo/?locale=pt_BR"
            target="_blank"
          >
            <S.IconFB src={FB} />
          </S.Link>
          <S.Link href="https://twitter.com/parcelamostudo" target="_blank">
            <S.IconTT src={TT} />
          </S.Link>
        </S.WrapperIcons>
        <S.Text4>
          Site desenvolvido com muito amor pela equipe Parcelamos
        </S.Text4>
      </S.Gradient>
    </S.Container>
  );
};
